import React from 'react';
import {
  Navigate,
} from 'react-router-dom';

import {
  ProResourceType,
  ClientResourceType,
} from '@gymcloud/core';

import {
  UsersPage,
  VideosPage,
  PaymentsPage,
  ProductsPage,
  DashboardPage,
  ExercisesPage,
  MarketplacePage,
  EventResultsPage,
  PersonalWorkoutsPage,
  PersonalProgramsPage,

  // PRO
  TagPage,
  BillingPage,
  ClientsPage,
  MessagesPage,
  CalendarPage,
  DocumentPage,
  SearchResults,
  EntityFolderPage,
  ClientGroupsPage,
  DocumentsListPage,
  NewAnnouncementPage,
  WorkoutTemplatesPage,
  ProgramTemplatesPage,
  PersonalPropertiesPage,

  // CLIENT
  AccountPage,
  PersonalEntityPage,
} from 'web-containers';

const proResourceTypes: { path: string, type: ProResourceType }[] = [
  {
    path: 'exercises_folder/:id',
    type: 'exercises',
  },
  {
    path: 'workout_templates_folder/:id',
    type: 'workoutTemplates',
  },
  {
    path: 'warmups_folder/:id',
    type: 'warmups',
  },
  {
    path: 'cooldowns_folder/:id',
    type: 'cooldowns',
  },
  {
    path: 'program_templates_folder/:id',
    type: 'programTemplates',
  },
];

const clientResourceTypes: { path: string, type: ClientResourceType }[] = [
  {
    type: 'personalExercises',
    path: 'personal_exercises',
  },
  {
    type: 'personalWarmups',
    path: 'personal_warmups',
  },
  {
    type: 'personalWorkouts',
    path: 'personal_workouts',
  },
  {
    type: 'personalCooldowns',
    path: 'personal_cooldowns',
  },
  {
    type: 'personalPrograms',
    path: 'personal_programs',
  },
];

const privateRoutes = [
  // COMMON ROUTES
  {
    path: 'welcome',
    element: <DashboardPage />,
  },
  {
    path: 'personal_workouts/:id/*',
    Component: PersonalWorkoutsPage,
  },
  {
    path: 'workout_exercises/:id/*',
    element: <ExercisesPage resourceType="workoutExercises" />,
  },
  {
    path: 'personal_programs/:id/*',
    Component: PersonalProgramsPage,
  },
  {
    path: 'events/:id/*',
    Component: EventResultsPage,
  },
  {
    path: 'workout_events/:id/*',
    Component: EventResultsPage,
  },
  {
    path: 'users/:id/*',
    Component: UsersPage,
  },
  {
    path: 'payments/:tab/*',
    Component: PaymentsPage,
  },
  {
    path: 'products',
    Component: ProductsPage,
  },
  {
    path: 'marketplace',
    Component: MarketplacePage,
  },
  {
    path: 'videos',
    element: <Navigate to="recent" replace />,
  },
  {
    path: 'videos/:order/*',
    Component: VideosPage,
  },
  {
    path: 'videos/:order/:page/*',
    Component: VideosPage,
  },

  // PRO ROUTES
  {
    path: 'billing',
    element: <Navigate to="invoices" replace />,
  },
  {
    path: 'billing/*',
    Component: BillingPage,
  },
  ...proResourceTypes.map(
    resource => ({
      path: resource.path,
      element: <EntityFolderPage resourceType={resource.type} />,
    }),
  ),
  {
    path: 'clients',
    element: <Navigate to="individuals" replace />,
  },
  {
    path: 'clients/*',
    Component: ClientsPage,
  },
  {
    path: 'client_groups/:id/*',
    Component: ClientGroupsPage,
  },
  {
    path: 'messages',
    Component: MessagesPage,
  },
  {
    path: 'messages/:id/:category',
    Component: MessagesPage,
  },
  {
    path: 'calendar',
    Component: CalendarPage,
  },
  {
    path: 'calendar/:date/:id',
    Component: CalendarPage,
  },
  {
    path: 'exercises/:id/*',
    element: <ExercisesPage resourceType="exercises" />,
  },
  {
    path: 'workout_templates/:id/*',
    element: <WorkoutTemplatesPage resourceType="workoutTemplates" />,
  },
  {
    path: 'warmups/:id/*',
    element: <WorkoutTemplatesPage resourceType="warmups" />,
  },
  {
    path: 'cooldowns/:id/*',
    element: <WorkoutTemplatesPage resourceType="cooldowns" />,
  },
  {
    path: 'program_templates/:id/*',
    Component: ProgramTemplatesPage,
  },
  {
    path: 'personal_properties',
    Component: PersonalPropertiesPage,
  },
  {
    path: 'search/:searchQuery/*',
    Component: SearchResults,
  },
  {
    path: 'tags/:tag/*',
    Component: TagPage,
  },
  {
    path: 'documents/:id/*',
    Component: DocumentPage,
  },
  {
    path: 'documents_folder/:id',
    Component: DocumentsListPage,
  },
  {
    path: 'new_announcement',
    Component: NewAnnouncementPage,
  },

  // CLIENT ROUTES
  ...clientResourceTypes.map(
    resource => ({
      path: resource.path,
      element: <PersonalEntityPage resourceType={resource.type} />,
    }),
  ),
  {
    path: 'personal_exercises/:id/*',
    element: <ExercisesPage requestType="exercises" resourceType="personalExercises" />,
  },
  {
    path: 'personal_warmups/:id/*',
    options: {
      type: 'personalWorkouts',
      addtionalType: 'personalWarmups',
    },
    element: <PersonalWorkoutsPage addtionalType="personalWarmups" />,
  },
  {
    path: 'personal_cooldowns/:id/*',
    element: <PersonalWorkoutsPage addtionalType="personalCooldowns" />,
  },
  {
    path: 'account/*',
    Component: AccountPage,
  },
  {
    path: 'documents',
    Component: DocumentsListPage,
  },
];

export default privateRoutes;
